import React from "react";
import "../../styles/categories.css"; // Updated CSS filename for clarity

const TrainingMethodology = () => {
  const methodologyData = [
    {
      id: 1,
      title: "Small Batch Size",
      desc: "for personal attention",
      // Image: A mentor helping a student 1-on-1 or a small group discussion
      img: "https://images.unsplash.com/photo-1544531586-fde5298cdd40?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 2,
      title: "Practical Approach",
      desc: "with real-life assignments",
      // Image: Students working collaboratively on laptops/projects
      img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 3,
      title: "Bilingual Teaching",
      desc: "(English + Tamil) for better understanding",
      // Image: A classroom setting or focus on communication/learning
      img: "https://i.pinimg.com/1200x/0f/ae/dd/0faeddb378cdf94ff8f7df83d2fd21fe.jpg"
    },
    {
      id: 4,
      title: "Flexible Timings",
      desc: "Weekday & Weekend Options",
      // Image: A workspace with a clock or a relaxed study environment implying flexibility
      img: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 5,
      title: "Hands-on Labs",
      desc: "for ERP and Computer Training",
      // Image: A computer lab environment focused on technology
      img: "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=800&q=80"
    }
  ];

  return (
    <section className="methodology-section container">
      {/* Section Title */}
      <h2 className="methodology-main-title text-center">
        Training Methodology
      </h2>

      <div className="methodology-wrapper">
        {methodologyData.map((item) => (
          <div key={item.id} className="methodology-item">
            {/* Image Container */}
            <div className="methodology-img-box">
              <img src={item.img} alt={item.title} className="methodology-img" />
            </div>
            
            {/* Text Content */}
            <h5 className="methodology-title">{item.title}</h5>
            <p className="methodology-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrainingMethodology;